/**
 * Requests to the tracker window from elsewhere at the table (the token menu): «В инициативу» before a fight opens the
 * gathering with these tokens ticked; «Хиты…» of a token in the fight opens its row's hit-point editor (initiative brief
 * 25.10, Р3/Р10). The window may not be mounted yet (it is lazy) — the request waits here until it reads it.
 */
type Req = { kind: 'collect'; tokenIds: string[] } | { kind: 'hp'; tokenId: string };

let pending: Req | null = null;
const listeners = new Set<() => void>();

export const INITIATIVE_OPEN_EVENT = 'roll1:initiative-open';

export function requestInitiative(req: Req): void {
  pending = req;
  for (const l of listeners) l();
  window.dispatchEvent(new CustomEvent(INITIATIVE_OPEN_EVENT));
}

/** Take the waiting request (once). */
export function takeInitiativeRequest(): Req | null {
  const r = pending;
  pending = null;
  return r;
}

export function subscribeInitiativeRequests(l: () => void): () => void {
  listeners.add(l);
  return () => { listeners.delete(l); };
}
